import React, { FC } from 'react';
import STTypo from '../typo/STTypo';
import './clusterTag.style.scss';
import { TypeOptions } from '../typo/STTypo.models';
import { handleClusterTagColor } from './clusterTag.utils';
import { useSelector } from 'react-redux';
import { getClusterByComponentId } from '../../redux/methodologyCluster/selectors';
import ClusterModal from '../clusterModal/clusterModal';
import { useCharacteristicClustering } from '../../containers/MethodologyContainer/hooks/use-characteristic-clustering';
import { ClusterEventType } from './clusterModal.models';
import { handleClusterName, useClusterSegment } from './useCluster';

interface ClusterTagProps {
  characteristicId?: string;
}

export const ClusterTag: FC<ClusterTagProps> = ({ characteristicId }) => {
  const clusterByComponent = useSelector(getClusterByComponentId(characteristicId));
  const { isClusterModalOpen, openClusterModal, closeClusterModal } = useCharacteristicClustering();
  const { handleClusterTracking } = useClusterSegment();
  if (!clusterByComponent?.cluster?.phenomenon_id) return <></>;
  const { nameColor, backgroundColor } = handleClusterTagColor(clusterByComponent?.cluster_index);

  const clusterName = handleClusterName(clusterByComponent?.cluster?.name);
  const { cluster } = clusterByComponent;
  const currentPhenomenonIds = [cluster?.phenomenon_unique_id, cluster?.phenomenon_id] as [string, string];

  const handleTagClick = () => {
    handleClusterTracking(ClusterEventType.Clicked, {
      clusterNames: [clusterName],
      numberOfClusters: 1,
      numberOfComponents: cluster?.components_ids?.length ?? 0
    });
    openClusterModal();
  };

  return (
    <>
      <button
        data-testid='cluster-name-tag'
        className='cluster-tag-button'
        onClick={handleTagClick}
        style={{ backgroundColor }}
        type='button'>
        <STTypo maxlength={12} type={TypeOptions.P2} color={nameColor}>
          {clusterName}
        </STTypo>
      </button>
      {isClusterModalOpen && cluster && (
        <ClusterModal
          isVisible={isClusterModalOpen}
          cluster={cluster}
          phenomenonIds={currentPhenomenonIds}
          onClose={closeClusterModal}
          selectedKeys={cluster?.components_ids ?? []}
        />
      )}
    </>
  );
};
